import React from 'react'
import styled from '@emotion/styled'

import {formatNum} from '../Number'

const Root = styled.span`
  white-space: nowrap;
`

const Price = ({
  value,
  discount,
  currency
}) => {
  currency = typeof currency === 'undefined' ? '₽' : currency
  let price = formatNum(value)
  let priceBeforeDiscount = ''

  if (discount > 0) {
    priceBeforeDiscount = `${price} ${currency}`
    price = formatNum(value * (1 - (parseFloat(discount) / 100)))
  }

  let [int, decimal] = price.split('.')
  const point = decimal ? '.' : ''

  if (currency) currency = ` ${currency}`

  return <Root>
    <s className="priceBeforeDiscount">{priceBeforeDiscount}</s>
    <span className="price">
      <span className="int">{int}</span>
      <span className="point">{point}</span>
      <span className="decimal">{decimal}</span>
      <span className="currency">{currency}</span>
    </span>
  </Root>
}

export default Price
